import { Link } from 'react-router-dom';
import I18n from '../../../config/i18n';
import Toggle from '../../../utils/Toggle';
import { getSearchPath } from '../../../routes/config';
import NavCollapsible from './NavCollapsible';
import Langswitch from '../langswitch/Langswitch';
import IdSearch from '../id-search/IdSearch';

import './MainNav.css';

interface MainNavProps {
  // eslint-disable-next-line camelcase
  is_host: boolean;
}

function anchorToDeletePost(e: React.MouseEvent<HTMLAnchorElement>) {
  e.preventDefault();

  const actionTarget = e.currentTarget.getAttribute('href');
  if (!actionTarget) {
    return;
  }

  const form = document.createElement('form');
  form.setAttribute('action', actionTarget);
  form.setAttribute('method', 'post');

  const input = document.createElement('input');
  input.setAttribute('type', 'hidden');
  input.setAttribute('name', '_method');
  input.setAttribute('value', 'delete');
  form.appendChild(input);

  document.getElementsByTagName('body')[0].appendChild(form);

  form.submit();
}

function LoggedIn(): JSX.Element {
  return (
    <span>
      <li className="main-nav-item main-nav-sign-out">
        <a href={`/${I18n.locale}/users/edit`} className="main-nav-item-link">
          {I18n.t('service_navigation.account')}
        </a>
      </li>
      <li className="main-nav-item main-nav-sign-out">
        <a
          href={`/${I18n.locale}/users/logout`}
          className="main-nav-item-link"
          onClick={anchorToDeletePost}
        >
          {I18n.t('shared.service_navigation.user.sign_out')}
        </a>
      </li>
    </span>
  );
}

function LoggedOut(): JSX.Element {
  return (
    <span>
      <li className="main-nav-item">
        <a href={I18n.t('shared.service_navigation.vouchers_url')} className="main-nav-item-link">
          {I18n.t('shared.service_navigation.vouchers')}
        </a>
      </li>
      <li className="main-nav-item main-nav-sign-in">
        <a href={`/${I18n.locale}/users/login`} className="main-nav-item-link">
          {I18n.t('shared.service_navigation.user.sign_in')}
        </a>
      </li>
    </span>
  );
}

// eslint-disable-next-line camelcase
export default function MainNav({ is_host }: MainNavProps): JSX.Element {
  return (
    <nav className="main-nav">
      <NavCollapsible>
        <ul className="main-nav-list">
          <li className="main-nav-item main-nav-langswitch">
            <Langswitch />
          </li>
          <Toggle show="xs sm">
            <li className="main-nav-item">
              <Link to={getSearchPath()} className="main-nav-item-link">
                {I18n.t('notepad.search')}
              </Link>
            </li>
            <li className="main-nav-item">
              <IdSearch />
            </li>
            <li className="main-nav-item">
              <a
                href={I18n.t('shared.footer.breakfast_url')}
                className="main-nav-item-link"
                target="_blank"
                rel="noreferrer"
              >
                {I18n.t('shared.footer.breakfast')}
              </a>
            </li>
          </Toggle>
          {/* eslint-disable-next-line camelcase */}
          {is_host ? <LoggedIn /> : <LoggedOut />}
        </ul>
      </NavCollapsible>
    </nav>
  );
}
